import { useState, useEffect } from 'react';

const useNeoTheme = () => {
  const [theme, setTheme] = useState(() => document.body.getAttribute('data-theme') || 'light');
  useEffect(() => {
    const bodyElement = document.body;
    // Create a MutationObserver to observe changes in the `data-theme` attribute
    const observer = new MutationObserver(() => {
      setTheme(bodyElement.getAttribute('data-theme') || 'light');
    });

    observer.observe(bodyElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    // Cleanup
    return () => observer.disconnect();
  }, []);

  return theme;
};

export default useNeoTheme;
